module.exports = __webpack_public_path__ + "static/media/SLIDERS-PD-600.bdbba799.png";